module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "omni-chat no-print"
  }, [_c('div', {
    staticClass: "omni-chat__button",
    on: {
      "click": _vm.setOpenChat
    }
  }, [_c('transition', {
    attrs: {
      "name": "scaleIn",
      "mode": "out-in"
    }
  }, [(!_vm.isShowChat) ? _c('svg', {
    key: "chatClosed",
    staticClass: "icon-chat-group-alt tw-icon--small",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('rect', {
    staticClass: "secondary",
    attrs: {
      "width": "16",
      "height": "13",
      "x": "2",
      "y": "2",
      "rx": "2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "primary",
    attrs: {
      "d": "M6 16V8c0-1.1.9-2 2-2h12a2 2 0 0 1 2 2v13a1 1 0 0 1-1.7.7L16.58 18H8a2 2 0 0 1-2-2z"
    }
  })]) : _c('svg', {
    key: "chatOpen",
    staticClass: "tw-icon--small icon-close",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    staticClass: "primary",
    attrs: {
      "fill-rule": "evenodd",
      "d": "M15.78 14.36a1 1 0 0 1-1.42 1.42l-2.82-2.83-2.83 2.83a1 1 0 1 1-1.42-1.42l2.83-2.82L7.3 8.7a1 1 0 0 1 1.42-1.42l2.83 2.83 2.82-2.83a1 1 0 0 1 1.42 1.42l-2.83 2.83 2.83 2.82z"
    }
  })])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "chatFadeIn"
    }
  }, [(_vm.isShowChat) ? _c('div', {
    staticClass: "omni-chat__container"
  }, [_c('div', [_c('div', {
    staticClass: "omni-chat__container__header"
  }, [_c('div', {
    staticClass: "omni-chat__logo"
  }, [_c('span', {
    staticClass: "icon-docendo"
  })]), _vm._v(" "), _c('h1', [_vm._v("Hej 👋")]), _vm._v(" "), _c('p', [_vm._v("Vi er dit Docendo-team. Vi står klar til at svare på dine spørgsmål :)")])]), _vm._v(" "), _c('div', {
    staticClass: "omni-chat__container__body"
  }, [_c('div', {
    staticClass: "omni-chat__container__body__box"
  }, [_c('h4', [_vm._v("Skriv en email eller ring til os")]), _vm._v(" "), _c('div', {
    staticClass: "customer-support__imgs"
  }, [_c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        zIndex: 2147483010
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
    }],
    attrs: {
      "src": _vm.anne,
      "content": "Anne"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        zIndex: 2147483010
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
    }],
    attrs: {
      "src": _vm.henrik,
      "content": "Henrik"
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        arrow: true,
        placement: 'bottom',
        zIndex: 2147483010
      }),
      expression: "{\n                  arrow: true,\n                  placement : 'bottom',\n                  zIndex: 2147483010\n                }"
    }],
    attrs: {
      "src": _vm.jeppe,
      "content": "Jeppe"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "support-options"
  }, [_c('li', [_c('span', {
    staticClass: "icon-question3"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://help.docendo.dk/da"
    }
  }, [_vm._v("Se supportforum")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "icon-envelop"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "mailto:kontakt@docendo.dk"
    }
  }, [_vm._v("kontakt@docendo.dk")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "icon-phone2"
  }), _vm._v(" +45 43 31 06 12")])]), _vm._v(" "), _c('a', {
    staticClass: "bttn bttn--primary bttn--primary--chat",
    attrs: {
      "target": "_blank",
      "href": "mailto:kontakt@docendo.dk?subject=Supporthenvendelse"
    }
  }, [_vm._v("Send os en email")]), _vm._v(" "), _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v("Chatsupport vender snart tilbage. Du kan altid sende os en email eller ringe, hvis du har spørgsmål.")])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69ebd77e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Help/HelpIcon.vue
// module id = 1698
// module chunks = 1